module.exports = __webpack_public_path__ + "static/media/constructo-logo.c6153f35.png";